// extracted by mini-css-extract-plugin
module.exports = {"delta2MaxDetail":"index2_delta2MaxDetail__LXy21"};